import type { ReactNode } from "react";
import { useDisableCRUD } from "../../store/admin/companiesStore";
import { useTranslation } from "react-i18next";

interface CRUDTooltipProps {
  children: ReactNode;
  className?: string;
}

/**
 * Wraps any CRUD-gated element and shows a "select a company" tooltip
 * when CRUD is disabled (no company selected).
 *
 * Usage:
 *   <CRUDTooltip>
 *     <button disabled={disableCRUD} ...>Add</button>
 *   </CRUDTooltip>
 */
export function CRUDTooltip({ children, className = "" }: CRUDTooltipProps) {
  const disableCRUD = useDisableCRUD();
  const { t } = useTranslation("common");

  return (
    <div className={`relative group/crud inline-flex ${className}`}>
      {children}
      {disableCRUD && (
        <div className="absolute bottom-full left-1/2 -translate-x-1/2 mb-2 px-3 py-1.5 bg-content text-app text-xs rounded-lg opacity-0 group-hover/crud:opacity-100 transition-opacity duration-200 pointer-events-none whitespace-nowrap z-50 shadow-lg">
          <i className="ri-building-line mr-1.5"></i>
          {t("selectCompanyTooltip", "Selecciona una compañía para continuar")}
          <div className="absolute top-full left-1/2 -translate-x-1/2 -mt-1 border-4 border-transparent border-t-content" />
        </div>
      )}
    </div>
  );
}
